module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_17.ef130032.jpg";